import ChargebeeAddon from 'modules/onboarding/lib/pricing/calculator/ChargebeeAddon'
import getPlanPricing from 'modules/onboarding/lib/pricing/calculator/getPricing'
import { Pricing } from 'modules/onboarding/lib/pricing/types'
import Feature from 'modules/onboarding/lib/pricing/plans/Feature'
import PlanVariant from 'modules/onboarding/lib/pricing/plans/PlanVariant'
import { PlanTypeEnum } from 'modules/onboarding/lib/pricing/plans/types'
import {
  DATO_PLAN_DESCRIPTION_FIELD,
  DATO_PLAN_ICON_FIELD,
  DATO_PLAN_ID_FIELD,
  DATO_PLAN_SEG_OPTION_FIELD,
  DATO_PLAN_TITLE_FIELD,
  DEFAULT_ICON,
  PRO_PLAN_TYPE,
  STARTER_PLAN_TYPE,
  getVariantFromID,
} from 'modules/onboarding/lib/pricing/plans/utils'

export function initNormalVariants(rawBundles: Pricing, country: string) {
  const normalVariants: PlanVariant[] = []

  rawBundles.allNormalPlans.forEach((normalPlan) => {
    const features = normalPlan.regions[0].features.map(
      (feature) => new Feature(feature.title, feature.tooltip, feature.highlightInModules ?? false)
    )
    const chargebeeAddons = normalPlan.regions[0].chargebeeAddons.map((addon) => {
      return new ChargebeeAddon(
        addon.addonId,
        addon.currencyCode,
        addon.period,
        addon.periodUnit,
        addon.pricingModel,
        addon.chargeType,
        addon.selectedCountries,
        addon.price,
        addon.tiers
      )
    })

    const pricing = getPlanPricing(chargebeeAddons, country)

    if (!pricing) return

    const planType: PlanTypeEnum = normalPlan[DATO_PLAN_ID_FIELD]
      .toLowerCase()
      .includes(PRO_PLAN_TYPE)
      ? PRO_PLAN_TYPE
      : STARTER_PLAN_TYPE

    const variantOptions = {
      id: normalPlan[DATO_PLAN_ID_FIELD],
      title: normalPlan[DATO_PLAN_TITLE_FIELD],
      type: getVariantFromID(normalPlan[DATO_PLAN_ID_FIELD]),
      description: normalPlan[DATO_PLAN_DESCRIPTION_FIELD],
      segmentationOption: normalPlan[DATO_PLAN_SEG_OPTION_FIELD],
      icon: normalPlan[DATO_PLAN_ICON_FIELD] || DEFAULT_ICON,
      features,
      pricing,
      planType,
    }

    normalVariants.push(new PlanVariant(variantOptions))
  })

  return normalVariants
}
